<template>
  <router-view />
</template>

<script>
export default {
  name: 'StorageSupplierPricesIndex'
}
</script>

